var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 25 25",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c(
        "g",
        {
          attrs: {
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            { attrs: { transform: "translate(-15.000000, -436.000000)" } },
            [
              _c(
                "g",
                { attrs: { transform: "translate(0.000000, 341.000000)" } },
                [
                  _c("rect", {
                    attrs: {
                      fill: _vm.color,
                      x: "15",
                      y: "95",
                      width: "25",
                      height: "25",
                      rx: "12.5"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        transform:
                          "translate(26.500000, 107.500000) rotate(180.000000) translate(-26.500000, -107.500000) translate(23.000000, 103.000000)",
                        fill: "currentColor"
                      }
                    },
                    [
                      _c("polygon", {
                        attrs: { points: "0 0 7 4.04139434 0 8.08278867" }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }